export default {"src":"/_next/static/media/mana4.8ccedb82.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};